/* ShopBebidas — Caderno de Origem
   Filtro por país (progressivo), URL ?pais=, acordeões mobile.
   Sem JS: todos os produtores ficam visíveis. */
(function () {
  'use strict';

  /* gate: só roda na página de produtores; as seções são irmãs,
     então os elementos são buscados no documento, não dentro do gate */
  if (!document.querySelector('[data-sbp-page]')) return;

  /* habilita o colapso dos grupos (CSS gateado por .sbp-js) */
  document.documentElement.classList.add('sbp-js');

  var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-sbp-filter]'));
  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-sbp-card]'));
  var groups = Array.prototype.slice.call(document.querySelectorAll('[data-sbp-group]'));
  var live = document.querySelector('[data-sbp-live]');
  var empty = document.querySelector('[data-sbp-empty]');
  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

  function apply(code, updateUrl) {
    var visible = 0;

    buttons.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-sbp-filter') === code ? 'true' : 'false');
    });

    cards.forEach(function (c) {
      var show = code === 'all' || c.getAttribute('data-country') === code;
      c.hidden = !show;
    });

    groups.forEach(function (g) {
      var match = code === 'all' || g.getAttribute('data-country') === code;
      g.hidden = !match;
      if (match) visible += g.querySelectorAll('[data-sbp-row]').length;
      if (code !== 'all' && match) g.setAttribute('data-open', 'true');
      if (isMobile() && code === 'all' && g === groups[0] && g.getAttribute('data-open') === 'false') {
        g.setAttribute('data-open', 'true');
      }
    });

    /* país filtrado: diretório na frente, destaques atrás (ou ocultos se vazios) */
    var dirRoot = document.querySelector('[data-sbp-directory-root]');
    if (dirRoot) {
      dirRoot.classList.toggle('sbp--filtered', code !== 'all');
      var featuredSec = dirRoot.querySelector('.sbp-featured');
      if (featuredSec) {
        var anyCard = cards.some(function (c) { return !c.hidden; });
        featuredSec.hidden = code !== 'all' && !anyCard;
      }
    }

    if (empty) empty.style.display = visible === 0 ? 'block' : 'none';

    if (live) {
      live.textContent = visible === 0
        ? 'Nenhum produtor encontrado para este país.'
        : visible + ' produtores exibidos.';
    }

    if (updateUrl && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      if (code === 'all') { url.searchParams.delete('pais'); }
      else { url.searchParams.set('pais', code); }
      window.history.replaceState(null, '', url.toString());
    }
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () {
      apply(b.getAttribute('data-sbp-filter'), true);
    });
  });

  groups.forEach(function (g) {
    var head = g.querySelector('[data-sbp-group-head]');
    if (!head) return;
    head.addEventListener('click', function () {
      g.setAttribute('data-open', g.getAttribute('data-open') === 'true' ? 'false' : 'true');
    });
  });

  /* desktop: todos os grupos começam abertos (no mobile, só o primeiro) */
  if (!isMobile()) {
    groups.forEach(function (g) { g.setAttribute('data-open', 'true'); });
  }

  /* estado inicial: ?pais= da URL (sem roubar o foco) */
  var params = new URLSearchParams(window.location.search);
  var initial = params.get('pais') || 'all';
  var valid = buttons.some(function (b) { return b.getAttribute('data-sbp-filter') === initial; });
  apply(valid ? initial : 'all', false);
})();
